<template>
    <div class="common-layout">
        <div v-if="asFlag" class="drawer-mask" @click="changeLfet"></div>

        <el-container class="container">
            <el-aside class="aside" :class="{ 'aside-open': asFlag }">
                <div class="user-profile">
                    <div class="avatar-wrapper">
                        <img src="../assets/favicon-96x96.png" class="avatar" alt="logo" />
                    </div>
                    <div class="info">
                        <p class="system-name">代理管理系统</p>
                        <p class="user-role">
                            <span class="role-dot"></span> 超级管理员
                        </p>
                    </div>
                </div>

                <el-scrollbar class="aside-scrollbar">
                    <el-menu
                        :default-active="activeMenu"
                        class="side-menu"
                        background-color="transparent"
                        text-color="#64748b"
                        active-text-color="#667eea"
                        :unique-opened="true"
                        router
                    >
                        <el-sub-menu index="1">
                            <template #title>
                                <el-icon><IconMenu /></el-icon>
                                <span>代理中心</span>
                            </template>
                            <el-menu-item index="/">
                                <el-icon><Monitor /></el-icon>
                                <span>软件列表</span>
                            </el-menu-item>
                        </el-sub-menu>
                    </el-menu>
                </el-scrollbar>
            </el-aside>

            <el-container class="main-container">
                <el-header class="header glass-header">
                    <div class="header-left">
                        <div class="menu-toggle" @click="changeLfet">
                            <el-icon :size="22">
                                <Expand v-if="!asFlag" />
                                <Fold v-else />
                            </el-icon>
                        </div>
                        <el-breadcrumb separator="/" class="breadcrumb-hidden-xs custom-breadcrumb">
                            <el-breadcrumb-item>首页</el-breadcrumb-item>
                            <el-breadcrumb-item>代理中心</el-breadcrumb-item>
                            <el-breadcrumb-item v-if="activeMenu === '/'">软件列表</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>

                    <div class="header-right">
                        <el-dropdown trigger="click" class="custom-dropdown">
                            <div class="user-dropdown">
                                <div class="user-avatar-small">
                                    <el-icon><UserFilled /></el-icon>
                                </div>
                                <span class="username">{{ username }}</span>
                                <el-icon class="arrow-icon"><ArrowDown /></el-icon>
                            </div>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item @click="updateDialog = true">
                                        <el-icon><Lock /></el-icon>修改密码
                                    </el-dropdown-item>
                                    <el-dropdown-item divided @click="logout" class="text-danger">
                                        <el-icon><SwitchButton /></el-icon>退出登录
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                    </div>
                </el-header>

                <el-main class="app-main">
                    <router-view v-slot="{ Component }">
                        <transition name="fade-transform" mode="out-in">
                            <component :is="Component" />
                        </transition>
                    </router-view>
                </el-main>
            </el-container>
        </el-container>

        <el-dialog
            v-model="updateDialog"
            title="安全设置"
            width="400px"
            append-to-body
            class="custom-dialog"
            :show-close="false"
        >
            <template #header="{ close, titleId, titleClass }">
                <div class="dialog-header">
                    <h4 :id="titleId" :class="titleClass">修改管理密码</h4>
                    <el-button link @click="close">
                        <el-icon :size="20"><Close /></el-icon>
                    </el-button>
                </div>
            </template>
            <div class="dialog-body">
                <el-alert 
                    title="新密码将在下次登录时生效，请妥善保管" 
                    type="warning" 
                    :closable="false" 
                    show-icon 
                    style="margin-bottom: 20px; border-radius: 8px;" 
                />
                <el-input 
                    type="password" 
                    v-model="newPassword" 
                    placeholder="请输入新密码 (最少6位)" 
                    show-password
                    size="large"
                    :prefix-icon="Lock"
                    class="custom-input"
                />
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="updateDialog = false" class="cancel-btn">取 消</el-button>
                    <el-button :loading="loading" type="primary" @click="updatePassword" class="confirm-btn">
                        确 认 修改
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
// 补充引入更丰富的图标，使界面细节更丰满
import { 
    Menu as IconMenu, ArrowDown, Expand, Fold, 
    Monitor, UserFilled, Lock, SwitchButton, Close 
} from '@element-plus/icons-vue'
import api from '@/utils/api'
import qs from 'qs';
import { useRouter, useRoute } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'

const router = useRouter();
const route = useRoute();

const username = ref(localStorage.getItem('username') || '未知用户');
const id = ref(localStorage.getItem('id'));
const activeMenu = computed(() => route.path);

const asFlag = ref(false);
const changeLfet = () => {
    asFlag.value = !asFlag.value;
}

const logout = () => {
    ElMessageBox.confirm('确定要退出代理管理系统吗？', '退出提示', {
        type: 'warning',
        confirmButtonText: '确定退出',
        cancelButtonText: '取消',
        customClass: 'custom-message-box' // 为 messagebox 预留自定义类名
    }).then(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        router.push('/login');
        ElMessage.success('已安全退出');
    }).catch(() => {});
}

const updateDialog = ref(false);
const newPassword = ref("");
const loading = ref(false);

const updatePassword = async () => {
    if (!newPassword.value) return ElMessage.warning("请输入新密码");
    if (newPassword.value.length < 6) return ElMessage.warning("密码长度不能少于6位");

    loading.value = true;
    try {
        const payload = qs.stringify({ newPassword: newPassword.value });
        const res = await api.post('/dl/update_password.php', payload);
        
        if (res.code == 200) {
            ElMessage.success(res.message || '密码修改成功');
            updateDialog.value = false;
            newPassword.value = "";
        } else {
            ElMessage.error(res.message || '修改失败');
        }
    } catch (error) {
        ElMessage.error("网络请求错误");
    } finally {
        loading.value = false;
    }
}

onMounted(() => {
    document.title = "代理系统 —— 控制面板";
});
</script>

<style lang="scss" scoped>
.common-layout {
    height: 100vh;
    width: 100vw;
    background-color: #f4f7fb; /* 与列表页呼应的底色 */
    overflow: hidden;
}

/* ================= 侧边栏 ================= */
.aside {
    width: 240px !important;
    height: 100%;
    background-color: #ffffff;
    transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    box-shadow: 2px 0 20px rgba(0, 0, 0, 0.03);
    z-index: 1001;
    display: flex;
    flex-direction: column;
    border-right: 1px solid #f0f2f5;

    @media screen and (max-width: 800px) {
        position: fixed;
        transform: translateX(-240px);
    }

    &.aside-open {
        transform: translateX(0);
    }

    .user-profile {
        padding: 24px 20px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #f0f2f5;
        
        .avatar-wrapper {
            width: 42px;
            height: 42px;
            border-radius: 12px;
            background: linear-gradient(135deg, #e0c3fc 0%, #8ec5fc 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 14px;
            box-shadow: 0 4px 10px rgba(142, 197, 252, 0.3);

            .avatar {
                width: 28px;
                height: 28px;
                object-fit: contain;
            }
        }

        .system-name {
            color: #1e293b;
            font-weight: 700;
            font-size: 16px;
            margin: 0 0 4px 0;
            letter-spacing: 0.5px;
        }

        .user-role {
            color: #64748b;
            font-size: 12px;
            margin: 0;
            display: flex;
            align-items: center;

            .role-dot {
                width: 6px;
                height: 6px;
                background-color: #10b981;
                border-radius: 50%;
                margin-right: 6px;
                box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.2);
            }
        }
    }

    .aside-scrollbar {
        flex: 1;
        padding: 12px 8px;
    }

    /* 菜单重绘为胶囊状 */
    .side-menu {
        border-right: none;

        :deep(.el-sub-menu__title), :deep(.el-menu-item) {
            border-radius: 8px;
            margin: 4px 0;
            height: 46px;
            line-height: 46px;
            color: #64748b;
            font-weight: 500;
            
            &:hover {
                background-color: #f8fafc !important;
                color: #334155;
            }
        }

        :deep(.el-menu-item.is-active) {
            background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%) !important;
            color: #667eea !important;
            font-weight: 600;

            &::before {
                content: '';
                position: absolute;
                left: -8px;
                top: 20%;
                height: 60%;
                width: 4px;
                background: linear-gradient(to bottom, #667eea, #764ba2);
                border-radius: 0 4px 4px 0;
            }
        }
    }
}

/* ================= 移动端遮罩 ================= */
.drawer-mask {
    background: rgba(15, 23, 42, 0.4);
    backdrop-filter: blur(2px);
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 1000;
    transition: opacity 0.3s;
}

/* ================= 顶部导航 ================= */
.glass-header {
    background: rgba(255, 255, 255, 0.7) !important;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
    height: 60px !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    z-index: 10;

    .header-left {
        display: flex;
        align-items: center;

        .menu-toggle {
            cursor: pointer;
            margin-right: 20px;
            color: #64748b;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            height: 36px;
            border-radius: 8px;
            transition: all 0.2s;

            &:hover { 
                background-color: #f1f5f9;
                color: #667eea; 
            }
        }

        .custom-breadcrumb {
            :deep(.el-breadcrumb__inner) {
                color: #64748b;
                font-weight: 500;
            }
            :deep(.el-breadcrumb__item:last-child .el-breadcrumb__inner) {
                color: #1e293b;
                font-weight: 600;
            }
        }

        @media screen and (max-width: 600px) {
            .breadcrumb-hidden-xs { display: none; }
        }
    }

    .header-right {
        .user-dropdown {
            display: flex;
            align-items: center;
            cursor: pointer;
            padding: 4px 8px;
            border-radius: 30px;
            transition: background-color 0.2s;

            &:hover { background-color: #f1f5f9; }

            .user-avatar-small {
                width: 32px;
                height: 32px;
                border-radius: 50%;
                background: #e2e8f0;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #64748b;
                margin-right: 10px;
            }

            .username {
                font-size: 14px;
                color: #334155;
                font-weight: 600;
                margin-right: 6px;
            }

            .arrow-icon { color: #94a3b8; font-size: 12px; }
        }
    }
}

/* ================= 主体内容 ================= */
.app-main {
    padding: 0;
    height: calc(100vh - 60px);
    overflow-x: hidden;
    overflow-y: auto;
    
    /* 定制滚动条 */
    &::-webkit-scrollbar { width: 6px; }
    &::-webkit-scrollbar-thumb {
        background: #cbd5e1;
        border-radius: 4px;
        &:hover { background: #94a3b8; }
    }
}

/* 路由切换过渡动画 */
.fade-transform-enter-active,
.fade-transform-leave-active {
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.fade-transform-enter-from {
    opacity: 0;
    transform: translateY(15px);
}
.fade-transform-leave-to {
    opacity: 0;
    transform: translateY(-15px);
}

/* ================= 弹窗美化 ================= */
:deep(.custom-dialog) {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);

    .el-dialog__header {
        padding: 0;
        margin: 0;
    }

    .dialog-header {
        padding: 20px 24px;
        border-bottom: 1px solid #f1f5f9;
        display: flex;
        justify-content: space-between;
        align-items: center;

        h4 { margin: 0; color: #1e293b; font-size: 16px; font-weight: 600; }
    }

    .dialog-body {
        padding: 24px;

        .custom-input .el-input__wrapper {
            background-color: #f8fafc;
            box-shadow: none;
            border: 1px solid transparent;
            border-radius: 8px;
            transition: all 0.2s;

            &.is-focus {
                background-color: #fff;
                border-color: #667eea;
                box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
            }
        }
    }

    .el-dialog__footer {
        padding: 0;
    }

    .dialog-footer {
        padding: 16px 24px;
        background: #f8fafc;
        border-top: 1px solid #f1f5f9;
        display: flex;
        justify-content: flex-end;
        gap: 12px;

        .cancel-btn, .confirm-btn {
            border-radius: 8px;
            font-weight: 500;
        }
        
        .confirm-btn {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border: none;
            &:hover { transform: translateY(-1px); box-shadow: 0 4px 12px rgba(118, 75, 162, 0.2); }
        }
    }
}

.text-danger {
    color: #ef4444 !important;
}
</style>